<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Iconos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.jpeg', style='height: auto;width: 200px;border-radius:5px')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Activación
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-flex(xs12 style='margin-top: 5px;')
          v-layout(wrap style='justify-content: space-between;')
            v-flex(xs4)
              v-text-field(v-model='search', label='Buscar')
            v-flex(xs4 style='display: flex;justify-content: center;padding-left:20px;')
              v-select(:items='filtros' v-model="seleccionFiltro" label="Estatus" @change='cambiarFiltro()')
            v-flex(xs4 style='display: flex;align-items: center;justify-content: flex-end;')
              v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
                template(v-slot:activator='{ on, attrs }')
                  v-text-field(v-model='dateRangeText' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' v-on='on')
                v-date-picker(multiple v-model='dates' no-title='' dark='')
                  v-spacer
                  v-btn(text='' color='primary' @click='$refs.menu1.save(dates)')
                    | OK
              v-btn.mx-0(icon @click='buscarFecha' style='background: white;border-radius: 100%;margin-left:10px !important;').elevation-4
                v-icon(color='#012147' style='font-size: 1.70rem;') search
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Activaciones
        v-data-table.elevation-1(:headers='headers' :pagination.sync="pagination" :search='search' :items="resultados" style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td {{ transform(props.item.fecha)}}
            td {{ props.item.co_cli }}
            td {{ props.item.cliente }}
            td {{ props.item.co_ven }}
            td {{ props.item.vendedor }}
            td {{ props.item.estatus }}
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";
export default {
  name: "Activacion",
  data: vm => ({
    ruta: serverImg,
    dates: [],
    dialog4: false,
    seleccionFiltro: 'todos',
    filtros: [
      {
        text: "Todos",
        value: "todos"
      },
      {
        text: "Activados",
        value: "Activado"
      },
      {
        text: "No activados",
        value: "No activado"
      },
    ],
    pagination: {
      sortBy: 'fecha', // The field that you're sorting by
      descending: true
    },
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    modal: false,
    search: "",
    resultadosres: [],
    resultados: [],
    headers: [
      { text: "Fecha", value: "fecha" },
      { text: "Código cliente", value: "co_cli" },
      { text: "Cliente", value: "cliente" },
      { text: "Código vendedor", value: "co_ven" },
      { text: "Vendedor", value: "vendedor" },
      { text: "Estatus", value: "estatus" }
    ],
    cre: "",
    mod: "",
    elm: ""
  }),
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    dateRangeText () {
      let todos = []
      let desde
      let hasta
      if (this.dates && this.dates[0])  {
        desde = this.formatDate(this.dates[0])
        todos.push(desde)
      }
      if (this.dates && this.dates[1]) {
        hasta = this.formatDate(this.dates[1])
        todos.push(hasta)
      }
      return todos.join(' ~ ')
    },
  },
  watch: {
    dates (val) {
      if (val && val.length > 2) {
        let res = []
        res.push(val[0])
        res.push(val[2])
        this.$nextTick(() => {
          this.dates = res
        })
      }
      if (val && val.length == 2 && val[0] > val[1]) {
        this.$swal.fire(
          "¡Atención!",
          "La fecha final debe ser mayor a la fecha inicial.",
          "error"
        );
        let res = []
        res.push(val[0])
        this.$nextTick(() => {
          this.dates = res
        })
      }
    },
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
  },
  created() {
    let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
    let hasta = this.$moment().format('YYYY-MM-DD')
    this.dates.push(desde)
    this.dates.push(hasta)
    this.verificacion();
    this.initialize();
  },
  methods: {
    transform(date) {
      return this.$moment(date).utc().format("DD/MM/YYYY")
    },
    cambiarFiltro() {
      let data = this.seleccionFiltro
      if (data) {
        this.resultados = []
        let res = []
        for (let i = 0; i < this.resultadosres.length; i++) {
          const el = this.resultadosres[i];
          if (data === "todos") {
            res.push(el)
          } else if (el.estatus === data) {
            res.push(el)
          }
        }
        this.$nextTick(() => {
          this.resultados = res
        })
      }
    },
    verificacion() {
      for (let i = 0; i < this.$store.state.adminavaflex.permisos.length; i++) {
        if (this.$store.state.adminavaflex.permisos[i].ruta === "Activacion") {
          for (
            let j = 0;
            j < this.$store.state.adminavaflex.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminavaflex.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminavaflex.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminavaflex.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    buscarFecha() {
      this.dialog4 = true
      let hasta = (this.dates && this.dates[1]) ? this.dates[1] : null
      if (this.dates && this.dates[0]) {
        Api.get("activacion/admin?desde="+this.dates[0]+'&hasta='+hasta+'&user='+this.$store.state.adminavaflex._id)
        .then(res => {
          this.dialog4 = false
          this.resultados = [];
          this.resultadosres = [];
          if (res.data && res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              const el = res.data[i];
              this.resultados.push(el)
              this.resultadosres.push(el)
            }
          }
        }).catch(err=>{
          console.log(err)
          this.dialog4 = false
        })
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Debes seleccionar al menos una fecha para realizar la operación",
          "error"
        );
      }
    },
    initialize() {
      this.date = new Date().toISOString().substr(0, 10)
      this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10))
      this.dates = []
      let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
      let hasta = this.$moment().format('YYYY-MM-DD')
      this.dates.push(desde)
      this.dates.push(hasta)
      Api.get("activacion/admin?desde="+this.dates[0]+'&hasta='+this.dates[1]+'&user='+this.$store.state.adminavaflex._id).then(res => {
        this.resultados = []
        this.resultadosres = []
        if (res.data && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const el = res.data[i];
            this.resultados.push(el)
            this.resultadosres.push(el)
          }
        }
      });
    }
  }
};
</script>
<style lang="scss">
.printPdf {
    @page :footer {
        display: none
    }
 
    @page :header {
        display: none
    }
}
.borderTb {
  border: 1px solid;
  text-align: center;
  width: 160px;
}
.withTd {
  width: 160px;
}
.textGrn {
  width: 100%;
  text-align: center;
}
.withTd2 {
  border: 2px solid;
  padding: 4px;
  font-weight: bold;
}
.withTd3 {
  padding: 4px;
  font-weight: bold;
}
.paddText {
  padding-right: 10px;
  font-size: 14px;
  font-weight: bold;
}
.divRect {
  width: 100px;
  height: 30px;
  border: 2px solid;
}
.divPrin {
  display: flex;
  align-items: center;
}
.divProd {
  background-color: gainsboro !important;
  font-weight: 400;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.divCli {
  margin-top: 20px;
  background-color: gainsboro !important;
  font-weight: 400;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
#printJS-form {
  table, th, td {
    border-collapse: collapse;
  }
}
</style>
